export enum SignalRType {
  Open = 0,
  Close = 1,
  Reconnecting = 2,
  SendMessage = 3,
}
